import React, { useState } from "react";

import "./style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faSearch } from "@fortawesome/free-solid-svg-icons";

const Navigation = () => {
  const [open, setOpen] = useState(false);
  const [openLang, setOpenLang] = useState(false);
  return (
    <>
      <header className="siteHeader">
        <div className="bottom-area"></div>
        <div className="fixArea">
          <div className="glovalNavi">
            <div className="inner">
              <div className="logo">
                <a className="noTrans" href="https://www.okayama-kanko.jp/">
                  <span className="hidden">
                    岡山観光WEB【公式】- 岡山県の観光・旅行情報ならココ！
                  </span>
                </a>
              </div>
              <nav className="clearfix">
                <div className="list">
                  <ul className="list-unstyled clearfix">
                    <li className="feature">
                      <a
                        className=""
                        href="https://www.okayama-kanko.jp/feature"
                      >
                        <span>
                          <img
                            src="https://www.okayama-kanko.jp/images/common/nav_feature.svg"
                            alt=""
                          />
                        </span>
                      </a>
                    </li>
                    <li className="course">
                      <a
                        className=""
                        href="https://www.okayama-kanko.jp/course"
                      >
                        <span>
                          <img
                            src="https://www.okayama-kanko.jp/images/common/nav_course.svg"
                            alt=""
                          />
                        </span>
                      </a>
                    </li>
                    <li className="spot">
                      <a className="" href="https://www.okayama-kanko.jp/spot">
                        <span>
                          <img
                            src="https://www.okayama-kanko.jp/images/common/nav_spot.svg"
                            alt=""
                          />
                        </span>
                      </a>
                    </li>
                    <li className="experience">
                      <a
                        className=""
                        href="https://www.okayama-kanko.jp/experience"
                      >
                        <span>
                          <img
                            src="https://www.okayama-kanko.jp/images/common/nav_experience.svg"
                            alt=""
                          />
                        </span>
                      </a>
                    </li>
                    <li className="gourmet">
                      <a
                        className=""
                        href="https://www.okayama-kanko.jp/gourmet"
                      >
                        <span>
                          <img
                            src="https://www.okayama-kanko.jp/images/common/nav_gourmet.svg"
                            alt=""
                          />
                        </span>
                      </a>
                    </li>
                    <li className="souvenir">
                      <a
                        className=""
                        href="https://www.okayama-kanko.jp/souvenir"
                      >
                        <span>
                          <img
                            src="https://www.okayama-kanko.jp/images/common/nav_souvenir.svg"
                            alt=""
                          />
                        </span>
                      </a>
                    </li>
                    <li className="event">
                      <a className="" href="https://www.okayama-kanko.jp/event">
                        <span>
                          <img
                            src="https://www.okayama-kanko.jp/images/common/nav_event.svg"
                            alt=""
                          />
                        </span>
                      </a>
                    </li>
                    <li className="reserve">
                      <a
                        className=""
                        href="https://www.okayama-kanko.jp/reserve"
                      >
                        <span>
                          <img
                            src="https://www.okayama-kanko.jp/images/common/nav_reserve.svg"
                            alt=""
                          />
                        </span>
                      </a>
                    </li>
                    <li className="access">
                      <a
                        className=""
                        href="https://www.okayama-kanko.jp/access"
                      >
                        <span>
                          <img
                            src="https://www.okayama-kanko.jp/images/common/nav_access.svg"
                            alt=""
                          />
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </nav>
              <a
                href="https://www.okayama-kanko.jp/favorite"
                className="favorite"
              >
                <span>
                  <img
                    src="https://www.okayama-kanko.jp/images/common/nav_favorite.svg"
                    alt="マイページ"
                  />
                </span>
              </a>
            </div>
          </div>
          {/* <div className="features">
            <div className="inner">
              <ul className="list-unstyled clearfix">
                <li>
                  <a href="https://www.okayama-kanko.jp/dc">
                    <span>おかやま夏旅キャンペーン</span>
                  </a>
                </li>
                <li>
                  <a href="https://www.okayama-kanko.jp/himawari">
                    <span>ひまわりの開花情報</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.okayama-kanko.jp/dc/omotenashi/"
                    rel="external noreferrer"
                    target="_blank"
                  >
                    <span>岡山おもてなしプロジェクト</span>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.okayama-kanko.jp/movie/"
                    rel="external noreferrer"
                    target="_blank"
                  >
                    <span>観光動画</span>
                  </a>
                </li>
                <li>
                  <a href="https://www.okayama-kanko.jp/okatabi">
                    <span>地元ライター旅レポ [おか旅]</span>
                  </a>
                </li>
              </ul>
            </div>
          </div> */}
        </div>
      </header>

      <div className="touchHeader">
        <div className="logo">
          <a className="noTrans" href="https://www.okayama-kanko.jp/">
            <span className="hidden">
              岡山観光WEB【公式】- 岡山県の観光・旅行情報ならココ！
            </span>
          </a>
        </div>
        <div className="rightSide">
          {/* <a className="touchCse js-touchCse" href="#">
            <FontAwesomeIcon icon={faSearch} />
          </a> */}
          <a
            className={`touchSw js-touchSw translate3d-on active.stop ${open ? "active" : ""
              }`}
            onClick={() => setOpen(!open)}
          >
            <i></i>
            <span></span>
          </a>
        </div>
      </div>

      <div
        className={`touchMenu js-touchMenu active.stop ${open ? "active" : ""}`}
      >
        <nav className="touch-gnavi1">
          <ul className="list-unstyled clearfix">
            <li className="feature ">
              <a href="https://www.okayama-kanko.jp/feature">
                <span>旬のおすすめ</span>
              </a>
            </li>
            <li className="course ">
              <a href="https://www.okayama-kanko.jp/course">
                <span>モデルコース</span>
              </a>
            </li>
            <li className="spot ">
              <a href="https://www.okayama-kanko.jp/spot">
                <span>観光スポット</span>
              </a>
            </li>
            <li className="experience active">
              <a href="https://www.okayama-kanko.jp/experience">
                <span>体験・ツアー</span>
              </a>
            </li>
            <li className="gourmet ">
              <a href="https://www.okayama-kanko.jp/gourmet">
                <span>グルメ</span>
              </a>
            </li>
            <li className="souvenir ">
              <a href="https://www.okayama-kanko.jp/souvenir">
                <span>おみやげ</span>
              </a>
            </li>
            <li className="event ">
              <a href="https://www.okayama-kanko.jp/event">
                <span>イベント</span>
              </a>
            </li>
            <li className="reserve ">
              <a href="https://www.okayama-kanko.jp/reserve">
                <span>宿泊予約</span>
              </a>
            </li>
            <li className="access ">
              <a href="https://www.okayama-kanko.jp/access">
                <span>アクセス</span>
              </a>
            </li>
            <li className="favorite ">
              <a href="https://www.okayama-kanko.jp/favorite">
                <span>マイページ</span>
              </a>
            </li>
          </ul>
        </nav>

        <div className="inner">
          {/* <nav className="touch-gnavi2">
            <ul className="list-unstyled clearfix">
              <li>
                <a href="https://www.okayama-kanko.jp/dc">
                  <span>おかやま夏旅キャンペーン</span>
                </a>
              </li>
              <li>
                <a href="https://www.okayama-kanko.jp/himawari">
                  <span>ひまわりの開花情報</span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.okayama-kanko.jp/dc/omotenashi/"
                  rel="external noreferrer"
                  target="_blank"
                >
                  <span>岡山おもてなしプロジェクト</span>
                </a>
              </li>
              <li>
                <a href="https://www.okayama-kanko.jp/okatabi">
                  <span>地元ライター旅レポ [おか旅]</span>
                </a>
              </li>
              <li>
                <a
                  href="https://www.okayama-kanko.jp/movie/"
                  rel="external noreferrer"
                  target="_blank"
                >
                  <span>観光動画</span>
                </a>
              </li>
            </ul>
          </nav> */}

          <section className="head-section">
            <div className="headerTools">
              <ul className="list-unstyled clearfix">
                <li>
                  <a
                    className="btn btn-block btn-dot-black"
                    href="https://www.okayama-kanko.jp/contact"
                  >
                    お問い合わせ
                  </a>
                </li>
                <li className="list">
                  <a href="#" data-toggle="dropdown" onClick={() => setOpenLang(!openLang)}>
                    <div className="icon">
                      <FontAwesomeIcon icon={faChevronDown} />
                    </div>
                    <span>Languages</span>
                  </a>
                  <ul className={`dropdown-menu ${openLang ? "active" : ""}`} role="menu">
                    <li>
                      <a
                        rel="external noreferrer"
                        href="https://www.okayama-japan.jp/en/"
                        target="_blank"
                      >
                        English
                      </a>
                    </li>
                    <li>
                      <a
                        rel="external noreferrer"
                        href="https://www.okayama-japan.jp/cn/"
                        target="_blank"
                      >
                        简体中文
                      </a>
                    </li>
                    <li>
                      <a
                        rel="external noreferrer"
                        href="https://www.okayama-japan.jp/tw/"
                        target="_blank"
                      >
                        繁體中文
                      </a>
                    </li>
                    <li>
                      <a
                        rel="external noreferrer"
                        href="https://www.okayama-japan.jp/ko/"
                        target="_blank"
                      >
                        한국어
                      </a>
                    </li>
                    <li>
                      <a
                        rel="external noreferrer"
                        href="https://www.okayama-japan.jp/th/"
                        target="_blank"
                      >
                        ภาษาไทย
                      </a>
                    </li>
                    <li>
                      <a
                        rel="external noreferrer"
                        href="https://www.okayama-japan.jp/fr/"
                        target="_blank"
                      >
                        Francais
                      </a>
                    </li>
                    <li>
                      <a
                        rel="external noreferrer"
                        href="https://www.okayama-japan.jp/de/"
                        target="_blank"
                      >
                        Deutsch
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default Navigation;
